<template>
    <div class="loto-events">
        <div class="loto__events-select-event">
            <ButtonCommon
                :type="isSelectedAll ? 'active' : 'outline'"
                value="Tout Sélectionner"
                :icon="isSelectedAll ? 'check-active' : 'check'"
                @on-click-button-common="onSelectAllEvents"
            />
        </div>
        <div class="loto__events__box">
            <div class="loto__events__box-item" v-if="!isArrayEmpty(dataDrawOfTheDay)">
                <h5 class="loto__events__box__title">
                    {{ getTranslatedText('Tirage du Jour') }}
                </h5>
                <div class="loto__events__box__list">
                    <template v-for="(v, i) in dataDrawOfTheDay" :key="i">
                        <div
                            :class="[
                                'loto__events__box__item',
                                {
                                    active: dataEventSelected.some((event) => event.event_id === v.event_id),
                                },
                            ]"
                            @click="onSelectItem(v)"
                        >
                            <span class="loto__events__box__item-name">
                                {{ getTranslatedText(v.draw_name) }}
                            </span>
                            <div class="loto__events__box__item-date">
                                <img
                                    class="loto__events__box__item-date__image"
                                    :src="require(`@/public/img/${$store.state.config.skin}/clock.svg`)"
                                />
                                <span class="loto__events__box__item-date__text">
                                    {{ renderDate(v.draw_date) }}
                                </span>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="loto__events__box-item" v-if="!isArrayEmpty(dataNextDraws)">
                <h5 class="loto__events__box__title">
                    {{ getTranslatedText('Prochains tirages') }}
                </h5>
                <div class="loto__events__box__list">
                    <template v-for="(v, i) in dataNextDraws" :key="i">
                        <div
                            :class="[
                                'loto__events__box__item',
                                {
                                    active: dataEventSelected.some((event) => event.event_id === v.event_id),
                                },
                            ]"
                            @click="onSelectItem(v)"
                        >
                            <span class="loto__events__box__item-name">
                                {{ getTranslatedText(v.draw_name) }}
                            </span>
                            <div class="loto__events__box__item-box-date">
                                <span class="loto__events__box__item-date__text">
                                    {{ renderDate(v.draw_date, true) }}
                                </span>
                                <div class="loto__events__box__item-date">
                                    <img
                                        class="loto__events__box__item-date__image"
                                        :src="require(`@/public/img/${$store.state.config.skin}/clock.svg`)"
                                    />
                                    <span class="loto__events__box__item-date__text">
                                        {{ renderDate(v.draw_date) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <div class="loto__events__box-button">
            <ButtonCommon type="default-3" value="Back" icon="arrow" className="loto__events__box-button__back" @on-click-button-common="onGoBack" />
            <ButtonCommon
                :type="dataEventSelected?.length > 0 ? 'active' : 'default-3'"
                :isDisable="dataEventSelected?.length === 0"
                value="Continue"
                iconRight="arrow"
                className="loto__events__box-button__continue"
                @on-click-button-common="onContinue"
            />
        </div>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language-mixins';
import functuonMixins from '@/mixins/function-utils';
import ButtonCommon from '@/components/common/button/button.vue';
import { formatDateUTC, isArrayEmpty } from '@/utils/utils';
import EventBus from '@/utils/EventBus';

export default {
    mixins: [languageMixins, functuonMixins],
    components: { ButtonCommon },
    props: {
        dataDrawOfTheDay: {
            type: Array,
            default: () => [],
        },
        dataNextDraws: {
            type: Array,
            default: () => [],
        },
        lengthDraw: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            dataEventSelected: [],
            isSelectedAll: false,
        };
    },
    watch: {
        dataEventSelected(newSelect, oldSelect) {
            if (newSelect !== oldSelect) {
                this.isSelectedAll = this.lengthDraw === newSelect.length;
            }
        },
    },

    methods: {
        onSelectItem(v) {
            let dataEventSelected = [...this.dataEventSelected];
            const index = dataEventSelected.findIndex((item) => item.event_id === v.event_id);
            if (index !== -1) dataEventSelected.splice(index, 1);
            else
                dataEventSelected.push({
                    draw_date: v.draw_date,
                    event_id: v.event_id,
                });

            this.dataEventSelected = dataEventSelected;
        },
        onSelectAllEvents() {
            if (this.lengthDraw === this.dataEventSelected.length) {
                this.dataEventSelected = [];
            } else {
                let dataAllDraw = [...this.dataDrawOfTheDay, ...this.dataNextDraws];
                const dataEventSelected = [...this.dataEventSelected];
                dataAllDraw.forEach((item) => {
                    const index = dataEventSelected.findIndex((v) => v.event_id === item.event_id);
                    if (index === -1)
                        dataEventSelected.push({
                            draw_date: item.draw_date,
                            event_id: item.event_id,
                        });
                });

                this.dataEventSelected = dataEventSelected;
            }
        },

        onGoBack() {
            const query = this.$route.query;
            this.$router.push({ path: '/loto-590', query });
        },

        onContinue() {
            if (isArrayEmpty(this.dataEventSelected)) {
                const param = {
                    text: 'please choose the game',
                    type: 'warning',
                };
                EventBus.emit('show-notications', param);

                return false;
            }

            let game = this.$store.state.cart.games;
            game['events_selected'] = this.dataEventSelected;

            this.$store.commit('SET_EVENT_SELECTED', game);

            const query = this.$route.query;

            this.$router.push({ path: '/loto-numbers', query });
        },

        renderDate(date, isShowDate = false) {
            const dateFormat = formatDateUTC(date, 2);
            const { hour12h, convertHour, day, year, month } = dateFormat;
            let valueDate = isShowDate ? `${day}/${month}/${year}` : `${hour12h}${convertHour}`;

            return valueDate;
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/loto/events.scss';
</style>
